import type { HTMLAttributes } from "react";
import { cx } from "./fieldContext";

/** Zusammenhängende Knopfgruppe (Ersatz für Antd `Button.Group`). */
export function ButtonGroup({ className, ...rest }: HTMLAttributes<HTMLDivElement> & { size?: "small" | "middle" | "large" }) {
  const { size: _size, ...divProps } = rest as HTMLAttributes<HTMLDivElement> & { size?: string };
  return <div role="group" className={cx("ck-btn-group", className)} {...divProps} />;
}
